import React from 'react';
import { Link } from 'react-router-dom';
import { articlesForIcp } from './aeoArticlesData';
import { aeoCoverForSlug } from './aeoCovers';

/**
 * Hub-page "Resources" block — links down to every AEO article in this ICP's cluster
 * (hub-and-spoke internal linking). Rendered below main hub content, above the footer.
 * Cards reuse the resources-page .lp-res-card design (cover, category, title, excerpt)
 * so the hub sections match the /resources grid exactly.
 */
const AeoResourcesSection = ({ icpSlug, heading = 'Resources' }) => {
    const articles = articlesForIcp(icpSlug);
    if (!articles.length) return null;

    return (
        <section className="lp-aeo-resources">
            <div className="lp-aeo-inner">
                <h2 className="lp-h2">{heading}</h2>
                <div className="lp-aeo-resources-grid">
                    {articles.map(a => {
                        const href = `/${a['icpSlug']}/${a['slug']}`;
                        return (
                            <div className="lp-res-card lp-aeo-res-card" key={a['slug']}>
                                <Link to={href} className="img cp" style={{ backgroundImage: `url(${aeoCoverForSlug(a['slug'], a['image'])})`, display: 'block' }} aria-label={a['title']} />
                                <div className="body">
                                    <div className="cats">{a['category']}</div>
                                    <Link to={href} style={{ textDecoration: 'none', color: 'inherit' }}><h3 className="cp">{a['title']}</h3></Link>
                                    <p>{a['metaDescription'].replace(/\s*Last updated:.*$/, '')}</p>
                                    <Link to={href}>Read article →</Link>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default AeoResourcesSection;
